<div class="grid grid--va-middle">
  <div class="grid__box grid__box--size-min">Массовые операции с бригадами:</div>
  <div class="grid__box grid__box--size-min">
    <app-role-access [action]="'disable'" [permission]="'brigade.edit'" [placement]="'bottom-left'">
      <button
        data-role-element
        type="button"
        class="button"
        [disabled]="brigadeOperations && brigadeOperations.brigadesList && brigadeOperations.brigadesList.length < 1"
        (click)="onOpenDisbandmentConfirmDialog.emit()"
        id="appDisbandmentBrigades"
      >
        Расформировать
      </button>
    </app-role-access>
  </div>
  <div class="grid__box grid__box--size-min">
    <app-role-access [action]="'disable'" [permission]="'brigade.edit'" [placement]="'bottom-left'">
      <button
        data-role-element
        type="button"
        class="button"
        [disabled]="brigadeOperations && brigadeOperations.brigadesList && brigadeOperations.brigadesList.length < 2"
        (click)="onOpenMergeDialog.emit()"
        id="appMergeBrigades"
      >
        Объединить
      </button>
    </app-role-access>
  </div>
</div>
